let domain = 'www.subpop.com';

/* excerpt text     */
$.fn.showMore = function (options) {
    return this.each(function () {
        var container = $(this);
        var display = container.parent().css('display');
        var content = $('.excerpt', this);

        if (display == "none") {
            container.parent().css('display', 'block');
            var contentHeight = content.height();
            container.parent().css('display', '');

        } else {
            var contentHeight = content.height();
        }

        //check how much content exists
        if (contentHeight > options) {
            content.addClass('less');
            container.append('<a class="show-more">Read more</a>');
            $('.show-more').on("click", function () {
                content.toggleClass('less');
                $('html, body').animate({
                    scrollTop: $(content).offset().top
                }, 300);
                if ($(content).hasClass('less')) {
                    $(this).text('Read more');
                } else {
                    $(this).text('Show less');
                }
            })
        }
        container.removeClass('loading');
    });
};

function known_bad_slug(slug) {
  if (slug == 'vendors' || slug == 'all' || slug == '' || slug == null) {
    return true;
  }
  else {
    return false;
  }
}

function getMainInfo(slug) {
  if (known_bad_slug(slug)) {
    return;
  }

  $.ajax({
    dataType: 'text',
    url: "https://" + domain + "/artists/" + slug + "/main_info.json",
    success:function(artist) {
      var response = $.parseJSON(artist);
      if (artist != null) {
        $(".artist-tab").show();
        drawHeader(response.artist.name);
        drawMainSidebar(response.artist);
        drawBio(response.artist.description);
      }
    },
    error:function() {
      //alert("Could not load the artist description");
    }
  });
}

function getSupplementalInfo(slug) {
  if (known_bad_slug(slug)) {
    return;
  }

  $.ajax({
    dataType: 'text',
    url: "https://" + domain + "/artists/" + slug + "/supplemental.json",
    success:function(artist) {
      var response = $.parseJSON(artist);
      drawVideo(response.artist.video);
      drawPress(response.artist.press);
      drawTourDates(response.artist.tour_dates);
    },
    error:function() {
      //alert("Could not load the artist details");
    }
  });
}

function drawHeader(name) {
  $("#artist-header").append("<h2>" + name + "</h2>");
}

function drawMainSidebar(about) {
  drawPhotos(about.photos);
  drawSocials(about.socials);
  drawSites(about.site_info);
}

function drawSites(sites) {
  var sitesDiv = "<ul>";

  sites.forEach((property, index) => {
    console.log(property.name);
    console.log(property.category);
    console.log(property.link);

    sitesDiv = sitesDiv + "<li><a href=\"" + property.link + "\">" + property.link + "</a></li>";
  });

  $("#artist-sites").append(sitesDiv + "</ul>");
}

function drawSocials(socials) {
  var socialDiv = "<ul class=\"inline-list social-icons artist-social-icons\">";

  socials.forEach((property, index) => {
    console.log(property.name);
    console.log(property.category);
    console.log(property.link);
    socialDiv = socialDiv + "<li class=\"li-artist-social\"> <a class=\"icon-fallback-text\" href=\"" + property.link + "\" target=\"_blank\" aria-describedby=\"a11y-new-window-external-message\">";

    if (property.category == "tiktok") {
      socialDiv = socialDiv + "<span class=\"icon icon-tiktok\" aria-hidden=\"true\" style=\"width:22px; fill:black\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\'icon\' id=\"icons\" viewBox=\"0 0 512 512\"><path d=\"M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z\"/></svg></span></a></li>";
    }
    else if (property.category == "spotify") {
      socialDiv = socialDiv + "<span class=\"icon icon-spotify\" aria-hidden=\"true\" style=\"width:22px; fill:black; padding-top:3px\"><svg xmlns=\"http://www.w3.org/2000/svg\" shape-rendering=\"geometricPrecision\" text-rendering=\"geometricPrecision\" image-rendering=\"optimizeQuality\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" viewBox=\"0 0 512 512\"><path d=\"M105 0h302c57.928.154 104.845 47.072 105 104.995V407c-.155 57.925-47.072 104.844-104.996 104.998L105 512C47.074 511.844.156 464.925.002 407.003L0 105C.156 47.072 47.074.154 104.997 0H105zm150.998 71.497C154.101 71.497 71.492 154.102 71.492 256c0 101.902 82.609 184.504 184.506 184.504 101.909 0 184.509-82.6 184.509-184.504 0-101.892-82.6-184.495-184.512-184.495l.003-.011v.003zm84.615 266.109c-3.304 5.419-10.399 7.14-15.821 3.811-43.318-26.461-97.854-32.452-162.079-17.78-6.189 1.41-12.357-2.467-13.77-8.659-1.415-6.191 2.448-12.359 8.652-13.769 70.284-16.057 130.572-9.143 179.207 20.578 5.421 3.326 7.14 10.397 3.811 15.819zm22.584-50.238c-4.166 6.767-13.022 8.904-19.786 4.742-49.597-30.485-125.194-39.315-183.857-21.504-7.607 2.296-15.642-1.991-17.949-9.584-2.293-7.61 1.996-15.627 9.592-17.94 67.006-20.331 150.308-10.484 207.264 24.514 6.764 4.166 8.901 13.023 4.737 19.779l.002-.004-.003-.003zm1.94-52.313c-59.468-35.32-157.578-38.567-214.353-21.336-9.116 2.766-18.759-2.379-21.521-11.499-2.762-9.123 2.381-18.756 11.502-21.526 65.175-19.786 173.52-15.963 241.984 24.68 8.218 4.87 10.908 15.459 6.037 23.648-4.849 8.2-15.468 10.904-23.641 6.033h-.008z\"/></svg></span></a></li>";
    }
    else {
      socialDiv = socialDiv + "<span class=\"icon icon-" + property.category + "\" aria-hidden=\"true\" style=\"color:black;\"></a></li>";
    }
  });

  $("#artist-socials").append(socialDiv + "</ul>");
}


/**
  sized: max_600_400
  max: max_960
  thumb: square_80
  cropped_220_160 cropped_220_160
*/
function drawPhotos(photos) {
    var modalDiv = "";
    photos.forEach((photo, index) => {
        modalDiv = modalDiv + "<div class=\"slide\"><img src=\"" + photo.max + "\" class=\"image-slide\"/>";
        modalDiv = modalDiv + creditText(photo.credit, 'white') + "</div>";
    });

    modalDiv = modalDiv + "<a class=\"previous\" onclick=\"changeSlide(-1)\">&#10094;</a>";
    modalDiv = modalDiv + "<a class=\"next\" onclick=\"changeSlide(1)\">&#10095;</a>";

  $(".modal-content").append(modalDiv)

    var thumbsDiv = "<div id=\"artist-thumbs\">";
    photos.forEach((photo, index) => {
        var slider = index + 1;
        var thumb = "<div class=\"col\"><img src=\"" + photo.thumb + "\" onclick=\"openLightbox();toSlide(" + slider + ")\" class=\"hover-shadow preview\"/></div>";
        thumbsDiv = thumbsDiv + thumb;
    });
    thumbsDiv = thumbsDiv + "</div>"

    var photoDiv = "<div id=\"main-artist-photo\">";
    photos.forEach((photo, index) => {
        if (index == 0) {
            photoDiv = photoDiv + "<img src=\"" + photo.sized + "\" onclick=\"openLightbox();toSlide(1)\" class=\"hover-shadow \"/>";
            photoDiv = photoDiv + creditText(photo.credit, 'black') + "</div>";
        }
    });
    $("#photos").append(photoDiv);
    $("#photos").append(thumbsDiv);
}


// The credit text below photos
function creditText(credit, color) {
  if (credit != null && credit != "") {
    return "<p class=\"photo-credit\" style=\"color: " + color + " !important\">Photo credit: " + credit + "</p>"
  }
  else {
    return "";
  }
}

function drawVideo(videos) {
  if (videos["videos"].length > 0) {
      $("#video-button").show();
      videos["videos"].forEach((video, index) => {
          if (index == 0) {
              $("#video-player").append(video.embed);

              if (videos.video_playlist_url != null) {
                  var playlist = "<a href=\"" + videos.video_playlist_url + "\" class=\"clearfix\" target=\"_blank\"><span class=\"ytThumb\"><h3>" + videos.video_playlist_text + "</h3></a>";
                  $(".play-list-link").append(playlist);
              }
          }
          var videoThumb = "<li class=\"grid-number\"><a href=\"" + video.link + "\"></a></li>";
          $("#video-thumbs").append(videoThumb);
      });

      /* youtube playlist */
      $("#video-thumbs").ytplaylist({
          addThumbs: true,
          playerWidth: '460',
          playerHeight: '284',
          thumbSize: 'medium',
          showRelated: false,
          holderId: 'video-player'
      });
      $('.yt-vid').click(function () {
          $('#video-player').fadeIn();
          $('#video-close').fadeIn();
          $('html, body').animate({
              scrollTop: $("#video-player").offset().top
          }, 400);
      });
      $('#video-close').click(function () {
          $('#video-player').fadeOut().html('');
          $('#video-close').fadeOut();
      });
    }
}

function drawPress(press) {
    var contactsDiv = "<h6 class=\"artist-h6\">Contact Info</h6><ul class=\"press-list\">";
    press.contact_info.forEach((property, index) => {
        console.log(property.name);
        console.log(property.category);
        console.log(property.link);
        if (property.subtype == 'contact') {
            contactsDiv = contactsDiv + "<li class=\"press-content\">";
            contactsDiv = contactsDiv + "<div class=\"list-name \">" + property.display_category + "</div>";
            contactsDiv = contactsDiv + "<div class=\"flexbox-item-3\"><a href=\"mailto:" + property.email + "\"> " + property.name + "</a>";
            if (property.link != null) {
                contactsDiv = contactsDiv + "<a href=\"" + property.link + "\">" + property.link + "</a>";
            }
            contactsDiv = contactsDiv + "</div></li>";
        }
        else if (property.subtype == 'site') {
            contactsDiv = contactsDiv + "<li><a href=\"" + property.link + "\">" + property.name + "</a></li>";
        }
   });
  if (press.default_publicity != null) {
    contactsDiv = contactsDiv + "<li class=\"press-content\">";
    contactsDiv = contactsDiv + "<div class=\"list-name \">" + press.default_publicity[0].display_category + "</div>";
    contactsDiv = contactsDiv + "<div class=\"flexbox-item-3\"><a href=\"mailto:" + press.default_publicity[0].email + "\"> " + press.default_publicity[0].name + "</a>";
    contactsDiv = contactsDiv + "</div></li>";
  }
  $("#artist-press").append(contactsDiv + "</ul>");

  if (press.bios.length > 0 || press.admats.length > 0) {
      var promoDiv = "<h6 class=\"artist-h6\">Promotional Material </h6><ul style=\"list-style-type: none;\">";
      press.bios.forEach((bio, index) => {
          promoDiv = promoDiv + "<li><a href=\"" + bio.url + "\">" + bio.name + "</a>" + "<span class=\"press-file-caption\"> (bio - " + bio.size + ")</span></li>";
      });
      press.admats.forEach((admat, index) => {
          promoDiv = promoDiv + "<li><a href=\"" + admat.url + "\">" + admat.name + "</a>" + "<span class=\"press-file-caption\"> (admat - " + admat.size + ")</span></li>";
      });
      $("#artist-press").append(promoDiv + "</ul>");
  }

  if (press.photos.length > 0) {
      var artistPhotos = "<h6 class=\"artist-h6\">Promotional Photos</h6><ul class=\"grid-cover-photo-container\">";
      press.photos.forEach((photo, index) => {
          artistPhotos = artistPhotos + "<li class=\"grid-number\" style=\"max-width: 200px !important\"><a target=\"_blank\" href=\"" + photo.url + "\"><img src=\"" + photo.cropped_220_160 + "\"></a>";

          artistPhotos = artistPhotos + creditText(photo.credit) + "</li>";
      });
      $("#artist-press").append(artistPhotos + "</ul>");
  }

  if (press.cover_art.length > 0) {
      var coverArt = "<h6 class=\"artist-h6\">Cover Art</h6><ul class=\"grid-cover-photo-container\">";
      press.cover_art.forEach((photo, index) => {
          coverArt = coverArt + "<li class=\"grid-number\"><a target=\"_blank\" href=\"" + photo.url + "\"><img src=\"" + photo.square_140 + "\"></a>";
          coverArt = coverArt + "<p class=\"release-name\">" + photo.name + "</p></li>";
      });
      $("#artist-press").append(coverArt + "</ul>");
  }

  if (press.press_scans.length > 0 || press.press_links.length > 0) {
      var pressLinkDiv = "<header><h6 class=\"artist-h6\" class=\"section-head\">Press Clips</h6></header><ul class=\"press-list\">";

      if (press.press_scans.length > 0) {
          var pressLinkDiv = pressLinkDiv + "<li class=\"press-content\" style=\"border:none !important\"><div class=\"list-name\">PDFs</div><div class=\"flexbox-item-3\">";
          press.press_scans.forEach((scan, index) => {
          pressLinkDiv = pressLinkDiv + "<a href=\"" + scan.url + "\">" + scan.name + "(" + scan.size + ")</a><br/>";
        });
        pressLinkDiv = pressLinkDiv + "</div></li></br>";
      }
      if (press.press_links.length > 0) {
        pressLinkDiv = pressLinkDiv + "<li class=\"press-content\" style=\"border:none !important\"><div class=\"list-name\">Links</span></div><div class=\"flexbox-item-3\">"
        press.press_links.forEach((link, index) => {
          pressLinkDiv = pressLinkDiv + "<a href=\"" + link.link + "\">" + link.name + "</a><br/>";
        });
        pressLinkDiv = pressLinkDiv + "</div></li>";
      }
      pressLinkDiv = pressLinkDiv + "</ul>";
  }
  $("#artist-press").append(pressLinkDiv);
}

function drawTourDates(tour_dates) {
  var tourDatesDiv = "<ul class=\"tour-list\">";
  if (tour_dates["tour_dates"].length > 0) {
    $("#tour-dates-button").show();
    tour_dates["tour_dates"].forEach(function(tour_date, tourIndex) {
        tourDatesDiv = tourDatesDiv + "<li class=\"row collapse\"><span class=\"tour-date medium-4 large-3 columns\">";
        tourDatesDiv = tourDatesDiv + "<span class=\"date-weekday\">" + tour_date.week_day + "</span>";
        tourDatesDiv = tourDatesDiv + "<span class=\"date-date\"> " + tour_date.date_day + "</span><br/>";
        tourDatesDiv = tourDatesDiv + "<span class=\"tour-venue\">" + tour_date.venue + "</span>";
        tourDatesDiv = tourDatesDiv + "<span class=\"tour-city\"> " + tour_date.address + "</span>";
        tourDatesDiv = tourDatesDiv + "<span class=\"tour-description\"> " + tour_date.description + "</span>";
        if (tour_date.tickets != "") {
            tourDatesDiv = tourDatesDiv + "<span class=\"tour-ticket-link\"><a href=\"" + tour_date.tickets + "\"> (Tickets)</a></span></span></li>";
        }
        else {
            tourDatesDiv = tourDatesDiv + "</span></li>";
        }
    });
   }
  $("#artist-tour").append(tourDatesDiv + "</ul>");
}


function drawBio(description) {
  $('.excerpt').append(description);
  $('#artist-description').showMore(400);
};

function openTab(evt, tabName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

function openLightbox() {
  document.getElementById('Lightbox').style.display = 'block';
  window.addEventListener(
    "keydown",
    (event) => {
      if (event.defaultPrevented) {
        return; // Do nothing if event already handled
      }

      switch (event.code) {
        case "Escape":
          closeLightbox();
          break;
        case "ArrowLeft":
          changeSlide(-1)
          break;
        case "ArrowRight":
          changeSlide(1)
          break;
      }
  });
}

var slideIndex = 1;
showSlide(slideIndex);

function closeLightbox() {
    document.getElementById('Lightbox').style.display = 'none';
}

function changeSlide(n) {
    showSlide(slideIndex += n);
}

function toSlide(n) {
    showSlide(slideIndex = n);
}

function showSlide(n) {
  const slides = document.getElementsByClassName('slide');

  if (n > slides.length) {
    slideIndex = 1;
  }

  if (n < 1) {
    slideIndex = slides.length;
  }

  for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
  }

  slides[slideIndex - 1].style.display = 'block';
}
